import '@/aura/css/app.pcss';
import Alpine from 'alpinejs';
import '@/aura/js/fade';
import '@/aura/js/slider';

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
  console.log(`
        ███████╗██╗   ██╗
        ██╔════╝██║   ██║
        ███████╗██║   ██║
        ╚════██║╚██╗ ██╔╝
        ███████║ ╚████╔╝
        ╚══════╝  ╚═══╝
        `);
});
